import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import PageTitle from "../../layout/PageTitle";
import { TEAMS } from "../../constants/TeamDetailsConstant";
import IncrementCounter from "../../common/IncrementCounter";

function TeamDetails({ setTab }) {
  const { doctorId } = useParams();
  const [teamTab, setTeamTab] = useState("expertise");
  const doctor = TEAMS.find((doc) => doc.id === doctorId);
  const handleTabClick = (tabName) => {
    setTeamTab(tabName);
  };
  const getTabData = () => {
    switch (teamTab) {
      case "expertise":
        return doctor.expertise.map((expertise, index) => (
          <div key={index} className="margin_bottom20">
            <h6 style={{ marginBottom: 0 }}>{expertise}</h6>
          </div>
        ));
      case "qualification":
        return (
          doctor.qualification &&
          doctor.qualification.map((item) => (
            <div className="margin_bottom20" key={item.degree}>
              <h6 style={{ marginBottom: 0 }}>{item.degree}</h6>
              <span className="ttm-textcolor-skincolor">{item.location}</span>
            </div>
          ))
        );
      case "memberships":
        return doctor.memberships.map((membership, index) => (
          <div key={index} className="margin_bottom20">
            <h6 style={{ marginBottom: 0 }}>{membership}</h6>
          </div>
        ));

      default:
        <></>;
    }
  };

  useEffect(() => {
    setTab("about");
  }, [teamTab, setTab]);

  return (
    <>
      <PageTitle page={doctor.name} setTab={setTab} />
      <div className="site-main">
        <section className="padding_top20  clearfix">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="ttm-team-member-single-content">
                  <div className="ttm-team-member-single-content-area">
                    <div className="ttm-bg ttm-col-bgcolor-yes ttm-bgcolor-grey spacing-9 res-991-margin_top0">
                      <div className="ttm-col-wrapper-bg-layer ttm-bg-layer"></div>
                      <div className="layer-content">
                        <div className="row no-gutters">
                          <div className="col-lg-3 col-md-6">
                            <div className="ttm-featured-wrapper">
                              <div className="featured-thumbnail mt_90 res-991-margin_top0">
                                <img
                                  className="img-fluid"
                                  src={doctor.img}
                                  alt={doctor.imgAlt}
                                  width="250"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-9 col-md-6">
                            <div className="ttm-team-member-content padding_left50 res-767-padding_left0 res-767-padding_top40">
                              <div className="ttm-team-member-single-list">
                                <h2 className="ttm-team-member-single-title">
                                  {doctor.name}
                                </h2>
                                <div className="ttm-team-member-single-position">
                                  {doctor.profession}
                                </div>
                                <div className="ttm-team-data">
                                  <div className="ttm-team-details-wrapper">
                                    <ul className="ttm-team-details-list clearfix">
                                      <li>
                                        <div className="ttm-team-list-title ttm-textcolor-darkgrey">
                                          Summary :
                                        </div>
                                        <div className="ttm-team-list-value">
                                          {doctor.summary}
                                        </div>
                                      </li>
                                      <li>
                                        <div className="ttm-team-list-title ttm-textcolor-darkgrey">
                                          Experience :
                                        </div>
                                        <div className="ttm-team-list-value">
                                          {
                                            <IncrementCounter
                                              intialCount={doctor.yoe}
                                              startYear={2025}
                                              incrementPerYear={1}
                                            />
                                          }
                                          + years
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ttm-team-member-content">
                    <h3 className="fs-28">Overview</h3>
                    <div className="row align-items-center">
                      <div className="padding_right20">
                        <p style={{ textAlign: "justify" }}>
                          {doctor.overview}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="ttm-row ttm-bgcolor-grey padding_top70 padding_bottom55 clearfix">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="padding_bottom10 padding_top20 res-991-padding_top0">
                  <h3 className="fs-28">Honors and Awards</h3>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="featured-icon-box icon-align-before-content icon-ver_align-top margin_bottom20">
                      <div className="featured-icon padding_right10">
                        <div className="ttm-icon ttm-icon_element-fill ttm-icon_element-color-skincolor ttm-icon_element-size-md ttm-icon_element-style-rounded">
                          <i className="fa fa-trophy"></i>
                        </div>
                      </div>
                      <div className="featured-content">
                        <div className="featured-title">
                          <h3 className="font-weight-500">
                            {doctor.honours.heading}
                          </h3>
                        </div>
                        <div className="featured-desc">
                          <p style={{ textAlign: "justify" }}>
                            {doctor.honours.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12">
                <div className="ttm-tabs ttm-tab-color-grey ttm-tab-style-01 res-991-margin_top30 clearfix">
                  <ul className="tabs">
                    <li
                      className={`tab ${
                        teamTab === "expertise" ? "active" : ""
                      }`}
                    >
                      <a onClick={() => handleTabClick("expertise")}>
                        Expertise
                      </a>
                    </li>
                    <li
                      className={`tab ${
                        teamTab === "qualification" ? "active" : ""
                      }`}
                    >
                      <a onClick={() => handleTabClick("qualification")}>
                        Qualification
                      </a>
                    </li>
                    {doctor.memberships && (
                      <li
                        className={`tab ${
                          teamTab === "memberships" ? "active" : ""
                        }`}
                      >
                        <a onClick={() => handleTabClick("memberships")}>
                          Membership
                        </a>
                      </li>
                    )}
                  </ul>
                  <div className="content-tab">
                    <div className="content-inner active"> {getTabData()}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default TeamDetails;
